import palette from '@assets/theme/palette';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

const ErrorBoundaryStyledContainer = styled(Paper)`
  padding: 64px 32px;
  text-align: center;
  max-width: clamp(33vw, 768px, 95vw);
  margin: 0 auto 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .calculation-link {
    color: ${palette.light.blue[400]};
    font-size: 16;
    font-weight: 600;
    border-radius: 8px;
    background: #fff;
    border: none;
    box-shadow: 0px 0px 20px 0px rgba(0, 5, 115, 0.07);
    margin-top: 24px;

    &:hover {
      box-shadow: 0px 0px 20px 0px rgba(138, 141, 255, 0.28);
    }
  }
`;

export default ErrorBoundaryStyledContainer;
